import {useQuery} from 'react-query'
import {Error500} from '../../modules/errors/components/Error500'
import {RunnerBall} from '../../../components/FormLoader'
import TopBarProgress from 'react-topbar-progress-indicator'
import viewProps from '../viewProps'
import {fetchStudentsInTrip} from './api'
import StudentsInTripTable from './StudentsInTripTable'

interface StudentsInTripProps {
  tripId: string | number
}

function StudentsInTrip({tripId}: StudentsInTripProps) {
  const {data, isLoading, isError, isFetching, refetch} = useQuery(
    ['student_in_trip', tripId],
    () => fetchStudentsInTrip(tripId),
    {
      refetchOnWindowFocus: false,
    }
  )

  if (isLoading) {
    return <RunnerBall />
  }

  if (isError) {
    return (
      <div className="text-center">
        <Error500 />
      </div>
    )
  }
  return (
    <>
      <StudentsInTripTable
        studentData={data?.data || []}
        fieldsToLableMap={viewProps.StudentsInTrip.primaryFieldsToLabelMap}
        tripId={tripId}
        refetchStudentData={refetch}
      />
      {isFetching && <TopBarProgress />}
    </>
  )
}

export default StudentsInTrip
